(function () {
  'use strict';

  /* ── Config ── */
  // Centralized backend URL — set via theme.liquid bridge (window.KZ_BACKENDS).
  // Fallback preserva funcionamento se bridge falhar (theme.liquid revertido).
  var KZ_DESK_BASE = (window.KZ_BACKENDS && window.KZ_BACKENDS.kzDesk) || 'https://kzdesk.com';
  var API        = KZ_DESK_BASE + '/api/webchat';
  var XFER       = KZ_DESK_BASE + '/api/webchat/transfer';
  var EVENTS_API = KZ_DESK_BASE + '/api/webchat/events';

  /* ── DOM refs ── */
  var fab      = document.getElementById('kzFab');
  var backdrop = document.getElementById('kzBackdrop');
  var box      = document.getElementById('kzBox');
  var closeBtn = document.getElementById('kzClose');
  var msgEl    = document.getElementById('kzMessages');
  var inputBar = document.getElementById('kzInputBar');
  var field    = document.getElementById('kzField');
  var sendBtn  = document.getElementById('kzSend');
  var xferEl   = document.getElementById('kzTransfer');
  var phoneInp = document.getElementById('kzPhone');
  var xferBtn  = document.getElementById('kzTransferBtn');
  var welcome  = document.getElementById('kzWelcome');
  var scrollBtn = document.getElementById('kzScrollBtn');

  /* ── Logged-in customer detection ── */
  function toTitleCase(s){if(!s)return '';return String(s).trim().split(/\s+/).map(function(w){return w.charAt(0).toUpperCase()+w.slice(1).toLowerCase()}).join(' ')}
  var kzCustomer = window.__kzCustomer || null;
  if (kzCustomer) console.log('[KZ Chat] Logged-in customer:', kzCustomer.email, kzCustomer.first_name);

  /* ── State ── */
  var state = {
    open: false,
    loading: false,
    transferred: false,
    historyLoaded: false,
    sessionId: getSessionId()
  };
  var fileInput = document.getElementById('kzFileInput');
  var attachBtn = document.getElementById('kzAttach');
  var pendingImage = null;

  /* ── Personalized UX for logged-in customers ── */
  if (kzCustomer && kzCustomer.first_name) {
    var welcomeTitle = document.getElementById('kzWelcomeTitle');
    var welcomeSub = document.getElementById('kzWelcomeSub');
    if (welcomeTitle) welcomeTitle.textContent = 'Olá, ' + toTitleCase(kzCustomer.first_name) + '! 👋';
    if (welcomeSub) welcomeSub.textContent = 'Sou o assistente virtual da KZ Music Store. Como posso te ajudar?';
    field.placeholder = toTitleCase(kzCustomer.first_name) + ', como posso ajudar?';
  }

  /* ── Session ── */
  function randomSessionSuffix() {
    try {
      var cryptoObj = window.crypto || window.msCrypto;
      if (cryptoObj && cryptoObj.getRandomValues) {
        var bytes = new Uint8Array(6);
        cryptoObj.getRandomValues(bytes);
        return Array.prototype.map.call(bytes, function (b) {
          return ('0' + b.toString(16)).slice(-2);
        }).join('');
      }
    } catch (e) { /* fallback below */ }
    return Math.random().toString(36).slice(2, 10);
  }

  function getSessionId() {
    var key = 'kz_chat_sid';
    var sid = null;
    try { sid = localStorage.getItem(key); } catch (e) { /* private browsing */ }
    if (!sid) {
      sid = 'sess_' + Date.now() + '_' + randomSessionSuffix();
      try { localStorage.setItem(key, sid); } catch (e) {}
    }
    return sid;
  }

  /* ── Helpers ── */
  var isMobile = function () { return window.innerWidth <= 520; };

  /* XSS-safe: escapeHtml uses textContent (safe) then formatMsg processes the escaped string */
  function escapeHtml(text) {
    var el = document.createElement('span');
    el.textContent = text;
    return el.innerHTML;
  }

  function formatMsg(text) {
    text = escapeHtml(text);
    text = text.replace(/(https?:\/\/[^\s<&]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
    text = text.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/\*([^*\n]+)\*/g, '<strong>$1</strong>');
    text = text.replace(/^\s*[-*]\s/gm, '• ');
    return text;
  }

  var NEAR_BOTTOM_PX = 80;
  var userScrolledUp = false;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isNearBottom() {
    return msgEl.scrollHeight - msgEl.scrollTop - msgEl.clientHeight < NEAR_BOTTOM_PX;
  }

  function setScrollBtnVisible(visible) {
    scrollBtn.classList.toggle('kz-visible', visible);
    scrollBtn.setAttribute('aria-hidden', visible ? 'false' : 'true');
    scrollBtn.tabIndex = visible ? 0 : -1;
  }

  function updateScrollBtn() {
    setScrollBtnVisible(!isNearBottom());
  }

  scrollBtn.setAttribute('aria-hidden', 'true');
  scrollBtn.tabIndex = -1;
  msgEl.addEventListener('scroll', updateScrollBtn, { passive: true });
  msgEl.addEventListener('wheel', function (e) { if (e.deltaY < 0) userScrolledUp = true; }, { passive: true });
  msgEl.addEventListener('touchmove', function () { if (!isNearBottom()) userScrolledUp = true; }, { passive: true });
  msgEl.addEventListener('keydown', function (e) {
    if (['ArrowUp', 'PageUp', 'Home'].indexOf(e.key) !== -1) userScrolledUp = true;
  });
  scrollBtn.addEventListener('click', function () {
    userScrolledUp = false;
    scrollToBottom(true);
    setScrollBtnVisible(false);
  });

  function scrollToBottom(smooth) {
    if (smooth && !reduceMotion()) {
      msgEl.scrollTo({ top: msgEl.scrollHeight, behavior: 'smooth' });
    } else {
      msgEl.scrollTop = msgEl.scrollHeight;
    }
  }

  function timeLabel(date) {
    return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }

  /* ── Body scroll lock (iOS-correct) ──
     overflow:hidden does NOT prevent scroll on iOS Safari. The page keeps
     scrolling behind the modal. The proper pattern is position:fixed with
     a preserved scrollY, restored on unlock. */
  var bodyLock = {
    _scrollY: 0,
    _locked: false,
    lock: function () {
      if (!isMobile() || this._locked) return;
      this._locked = true;
      this._scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.top = '-' + this._scrollY + 'px';
      document.body.classList.add('kz-no-scroll');
    },
    unlock: function () {
      if (!this._locked) return;
      this._locked = false;
      document.body.classList.remove('kz-no-scroll');
      document.body.style.top = '';
      window.scrollTo(0, this._scrollY);
    }
  };

  /* ── Keyboard offset ──
     Publishes --kz-kb-offset CSS var; the box shrinks via `bottom` (GPU-
     friendly transition) instead of per-frame box.style.height writes which
     cause reflow and visible jank during iOS keyboard animation.

     Formula: keyboard size = layoutViewport - visualViewport.height.
     Do NOT subtract vv.offsetTop — that's the visual viewport's *position*
     within the layout viewport, not part of the keyboard size. iOS Safari
     bumps offsetTop when it scrolls the layout to bring a focused input
     into view, which would otherwise inflate the offset and collapse the
     chat box (page bleeds through below). */
  var keyboard = {
    _raf: null,
    init: function () {
      if (!window.visualViewport) return;
      var vv = window.visualViewport;
      var self = this;
      function onResize() {
        if (self._raf) return;
        self._raf = requestAnimationFrame(function () {
          self._raf = null;
          if (!state.open || !isMobile()) return;
          var kb = Math.max(0, window.innerHeight - vv.height);
          document.documentElement.style.setProperty('--kz-kb-offset', kb + 'px');
          if (!userScrolledUp) scrollToBottom(false);
        });
      }
      vv.addEventListener('resize', onResize);
    },
    reset: function () {
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
      document.documentElement.style.removeProperty('--kz-kb-offset');
    }
  };

  keyboard.init();

  /* ── Open / Close ── */
  function openChat() {
    state.open = true;
    box.classList.remove('kz-hidden');
    if (backdrop) backdrop.classList.remove('kz-hidden');
    fab.classList.add('kz-hidden');
    bodyLock.lock();
    loadHistory();
    if (!isMobile()) {
      setTimeout(function () { field.focus(); }, 150);
    }
  }

  function closeChat() {
    state.open = false;
    box.classList.add('kz-hidden');
    if (backdrop) backdrop.classList.add('kz-hidden');
    fab.classList.remove('kz-hidden');
    field.blur();
    keyboard.reset();
    bodyLock.unlock();
  }

  fab.addEventListener('click', openChat);
  closeBtn.addEventListener('click', closeChat);
  if (backdrop) backdrop.addEventListener('click', closeChat);

  /* ── Messages — innerHTML is safe because formatMsg only processes escapeHtml output ── */
  function addMessage(content, sender, skipScroll, ts) {
    if (welcome && welcome.parentNode) welcome.remove();
    var bubble = document.createElement('div');
    var cls = sender === 'visitor' ? 'kz-bubble--out'
            : sender === 'system' ? 'kz-bubble--sys'
            : 'kz-bubble--in';
    bubble.className = 'kz-bubble ' + cls;
    var t = ts ? new Date(ts) : new Date();
    bubble.innerHTML = formatMsg(content)
      + '<div class="kz-bubble__time">' + timeLabel(t) + '</div>';
    msgEl.appendChild(bubble);
    if (!skipScroll) scrollToBottom(true);
  }

  /* ── Typing indicator ── */
  function showTyping() {
    if (document.getElementById('kzTyping')) return;
    var el = document.createElement('div');
    el.className = 'kz-typing';
    el.id = 'kzTyping';
    el.innerHTML = '<span class="kz-typing__dot"></span><span class="kz-typing__dot"></span><span class="kz-typing__dot"></span>';
    msgEl.appendChild(el);
    scrollToBottom(false);
  }

  function hideTyping() {
    var el = document.getElementById('kzTyping');
    if (el) el.remove();
  }

  /* ── Image preview ── */
  function showImagePreview(dataUri) {
    removeImagePreview();
    var container = document.createElement('div'); container.className = 'kz-img-preview'; container.id = 'kzImgPreview';
    var img = document.createElement('img'); img.src = dataUri; container.appendChild(img);
    var removeBtn = document.createElement('button'); removeBtn.className = 'kz-img-preview__remove';
    removeBtn.textContent = '\u00d7';
    removeBtn.onclick = function() { pendingImage = null; removeImagePreview(); };
    container.appendChild(removeBtn);
    inputBar.parentNode.insertBefore(container, inputBar);
  }
  function removeImagePreview() { var el = document.getElementById('kzImgPreview'); if (el) el.remove(); }

  attachBtn.addEventListener('click', function() { fileInput.click(); });
  fileInput.addEventListener('change', function() {
    var file = this.files[0]; if (!file) return;
    if (file.size > 5 * 1024 * 1024) { addMessage('Imagem muito grande. Máximo 5MB.', 'system'); this.value = ''; return; }
    var reader = new FileReader();
    reader.onload = function(e) { pendingImage = { dataUri: e.target.result, name: file.name }; showImagePreview(pendingImage.dataUri); };
    reader.readAsDataURL(file); this.value = '';
  });
  msgEl.addEventListener('dragover', function(e) { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; });
  msgEl.addEventListener('drop', function(e) {
    e.preventDefault(); var file = e.dataTransfer.files[0];
    if (!file || !file.type.startsWith('image/')) return;
    if (file.size > 5 * 1024 * 1024) { addMessage('Imagem muito grande. Máximo 5MB.', 'system'); return; }
    var reader = new FileReader();
    reader.onload = function(ev) { pendingImage = { dataUri: ev.target.result, name: file.name }; showImagePreview(pendingImage.dataUri); };
    reader.readAsDataURL(file);
  });
  field.addEventListener('paste', function(e) {
    var items = e.clipboardData && e.clipboardData.items; if (!items) return;
    for (var i = 0; i < items.length; i++) {
      if (items[i].type.startsWith('image/')) {
        e.preventDefault(); var file = items[i].getAsFile();
        if (!file || file.size > 5 * 1024 * 1024) { addMessage('Imagem muito grande. Máximo 5MB.', 'system'); return; }
        var reader = new FileReader();
        reader.onload = function(ev) { pendingImage = { dataUri: ev.target.result, name: 'pasted-image' }; showImagePreview(pendingImage.dataUri); };
        reader.readAsDataURL(file); return;
      }
    }
  });

  /* ── History ── */
  async function loadHistory() {
    if (state.historyLoaded) return;
    state.historyLoaded = true;
    try {
      var res = await fetch(API + '?action=history&sessionId=' + encodeURIComponent(state.sessionId));
      if (!res.ok) return;
      var data = await res.json();
      var msgs = data.messages || [];
      if (!msgs.length) return;
      msgs.forEach(function (m) {
        var content = m.content || '';
        var products = null;
        var prodMatch = content.match(/\n?\[PRODUCTS:(\[[\s\S]*?\])\]/);
        if (prodMatch) { try { products = JSON.parse(prodMatch[1]); } catch(e) {} content = content.replace(prodMatch[0], ''); }
        // Fallback: strip any remaining internal tags (PRODUCTS, budget, etc)
        content = content.replace(/\[PRODUCTS:[\s\S]*$/g, '');
        content = content.replace(/<\w+:\w+>[\s\S]*?<\/\w+:\w+>/g, '');
        content = content.replace(/<(?:budget|token)\w*:\w*>[\s\S]*$/g, '');
        addMessage(content, m.sender === 'visitor' ? 'visitor' : 'bot', true, m.created_at);
        if (products && products.length) renderProductCards(products);
      });
      scrollToBottom(false);
    } catch (e) { /* silent */ }
  }

  /* ── Send ── */
  async function send() {
    var text = field.value.trim();
    var img = pendingImage;
    if ((!text && !img) || state.loading || state.transferred) return;
    userScrolledUp = false;
    field.value = '';
    field.style.height = 'auto';
    if (text) addMessage(text, 'visitor');
    if (img) {
      if (welcome && welcome.parentNode) welcome.remove();
      var imgBubble = document.createElement('div');
      imgBubble.className = 'kz-bubble kz-bubble--out';
      imgBubble.innerHTML = '<img src="' + img.dataUri + '" style="width:100%;height:auto;max-width:220px;max-height:180px;object-fit:contain;border-radius:6px;display:block"><div class="kz-bubble__time">' + timeLabel(new Date()) + '</div>';
      msgEl.appendChild(imgBubble); scrollToBottom(true);
    }
    pendingImage = null; removeImagePreview();
    state.loading = true;
    sendBtn.disabled = true;
    showTyping();
    try {
      var body = { sessionId: state.sessionId, message: text || '[Imagem enviada]', stream: true };
      if (img) body.image = img.dataUri;
      if (kzCustomer && kzCustomer.email) {
        body.customer_email = kzCustomer.email;
        body.customer_name = toTitleCase(kzCustomer.name) || '';
        body.customer_phone = kzCustomer.phone || '';
        body.customer_id = kzCustomer.id || '';
      }
      var res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      var ct = res.headers.get('content-type') || '';
      if (ct.includes('text/event-stream') && res.body) {
        var streamBubble = null;
        var textEl = null;
        var charQueue = [];
        var renderActive = false;
        var streamDone = false;
        var doneData = null;
        var streamKilled = false;

        function ensureBubble() {
          if (streamBubble) return;
          hideTyping();
          streamBubble = document.createElement('div');
          streamBubble.className = 'kz-bubble kz-bubble--in';
          var timeDiv = document.createElement('div');
          timeDiv.className = 'kz-bubble__time';
          timeDiv.textContent = timeLabel(new Date());
          var span = document.createElement('span');
          span.className = 'kz-stream-text';
          streamBubble.appendChild(span);
          streamBubble.appendChild(timeDiv);
          msgEl.appendChild(streamBubble);
          textEl = span;
        }

        function renderLoop() {
          if (!charQueue.length) {
            renderActive = false;
            if (streamDone) finalizeStream();
            return;
          }
          if (streamKilled) { charQueue.length = 0; renderActive = false; if (streamDone) finalizeStream(); return; }
          var batch = charQueue.splice(0, 3);
          var current = textEl.textContent + batch.join('');
          // Kill switch: if BOT_SUMMARY, RESUMO, or internal angle-bracket tags detected
          var killIdx = current.search(/\[BOT[_\s]?SUMMARY/i);
          if (killIdx === -1) killIdx = current.search(/\[RESUMO\]/i);
          if (killIdx === -1) killIdx = current.search(/<budget:/i);
          if (killIdx === -1) killIdx = current.search(/<\w+:\w+>/i);
          if (killIdx !== -1) { textEl.textContent = current.slice(0, killIdx).trim(); charQueue.length = 0; streamKilled = true; renderActive = false; if (streamDone) finalizeStream(); return; }
          textEl.textContent = current;
          if (!userScrolledUp && isNearBottom()) scrollToBottom(false);
          requestAnimationFrame(renderLoop);
        }

        function startRender() {
          if (renderActive) return;
          renderActive = true;
          requestAnimationFrame(renderLoop);
        }

        function finalizeStream() {
          if (!doneData) return;
          hideTyping();
          state.loading = false;
          sendBtn.disabled = false;
          if (doneData.silent) { if (streamBubble) streamBubble.remove(); userScrolledUp = false; return; }
          if (doneData.reply) {
            // formatMsg uses escapeHtml internally — safe against XSS
            if (!streamBubble) { addMessage(doneData.reply, 'bot'); }
            else { textEl.innerHTML = formatMsg(doneData.reply); }
            if (!userScrolledUp) scrollToBottom(true);
          }
          if (doneData.products && doneData.products.length) renderProductCards(doneData.products);
          if (doneData.transferPhone) showTransfer(doneData.transferPhone);
          userScrolledUp = false;
        }

        var reader = res.body.getReader();
        var decoder = new TextDecoder();
        var buf = '';
        // Inactivity watchdog: cancela stream se backend ficar 30s sem mandar
        // chunk (rede travou, função morreu, etc). Timer resetado a cada chunk.
        var inactivityTimer = null;
        function resetInactivityTimer() {
          if (inactivityTimer) clearTimeout(inactivityTimer);
          inactivityTimer = setTimeout(function () {
            try { reader.cancel(); } catch (_) {}
          }, 30000);
        }
        resetInactivityTimer();
        try {
          while (true) {
            var chunk = await reader.read();
            resetInactivityTimer();
            if (chunk.done) break;
            buf += decoder.decode(chunk.value, { stream: true });
            var parts = buf.split('\n');
            buf = parts.pop();
            var evType = '';
            for (var p = 0; p < parts.length; p++) {
              if (parts[p].startsWith('event: ')) evType = parts[p].slice(7);
              else if (parts[p].startsWith('data: ')) {
                try {
                  var ev = JSON.parse(parts[p].slice(6));
                  if (evType === 'delta' && ev.text) {
                    ensureBubble();
                    for (var ci = 0; ci < ev.text.length; ci++) charQueue.push(ev.text[ci]);
                    startRender();
                  } else if (evType === 'done') {
                    doneData = ev;
                    streamDone = true;
                    if (!renderActive) finalizeStream();
                  } else if (evType === 'error') {
                    hideTyping();
                    if (streamBubble) streamBubble.remove();
                    addMessage('Desculpe, ocorreu um erro. Tente novamente em instantes.', 'system');
                  }
                } catch (pe) {}
              }
            }
          }
        } catch (streamErr) {
          hideTyping();
          state.loading = false;
          sendBtn.disabled = false;
          if (!streamBubble || !textEl || !textEl.textContent.trim()) {
            if (streamBubble) streamBubble.remove();
            addMessage('Desculpe, ocorreu um erro. Tente novamente em instantes.', 'system');
          }
        } finally {
          if (inactivityTimer) clearTimeout(inactivityTimer);
        }
        if (!streamDone && !streamBubble) { hideTyping(); state.loading = false; sendBtn.disabled = false; }
      } else {
        var data = await res.json();
        hideTyping();
        if (data.reply) addMessage(data.reply, 'bot');
        if (data.products && data.products.length) renderProductCards(data.products);
        if (data.transferPhone) showTransfer(data.transferPhone);
        state.loading = false;
        sendBtn.disabled = false;
      }
    } catch (e) {
      hideTyping();
      addMessage('Desculpe, ocorreu um erro. Tente novamente em instantes.', 'system');
      state.loading = false;
      sendBtn.disabled = false;
    }
  }

  /* ── Transfer ── */
  function showTransfer(phone) {
    state.transferred = true;
    inputBar.style.display = 'none';
    xferEl.hidden = false;
    if (phone) phoneInp.value = phone;
    setTimeout(function () { phoneInp.focus(); }, 100);
  }

  async function doTransfer() {
    var digits = phoneInp.value.replace(/\D/g, '');
    if (digits.length < 8) {
      phoneInp.style.borderColor = '#ef4444';
      return;
    }
    xferBtn.disabled = true;
    xferBtn.textContent = 'Transferindo...';
    try {
      await fetch(XFER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: state.sessionId, phone: digits, visitorName: '' })
      });
      xferEl.hidden = true;
      inputBar.style.display = 'flex';
      addMessage(
        'Pronto! Você receberá uma mensagem no WhatsApp em instantes. Um atendente vai continuar seu atendimento por lá. 🎧',
        'system'
      );
      field.disabled = true;
      field.placeholder = 'Atendimento transferido para WhatsApp';
      sendBtn.disabled = true;
    } catch (e) {
      addMessage('Erro ao transferir. Tente novamente.', 'system');
      xferBtn.disabled = false;
      xferBtn.textContent = 'Continuar no WhatsApp';
    }
  }

  /* ── Product Cards ── */
  function fmtBRL(price) { return 'R$ ' + parseFloat(price).toFixed(2).replace('.', ','); }

  var productDetailsCache = {};

  function productImageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    if (image.src) return image.src;
    if (image.url) return image.url;
    if (image.preview_image) return productImageUrl(image.preview_image);
    if (image.previewImage) return productImageUrl(image.previewImage);
    return '';
  }

  function variantImageUrl(variant, fallback) {
    if (!variant) return fallback || '';
    var candidates = [
      variant.image,
      variant.image_url,
      variant.imageUrl,
      variant.featured_image,
      variant.featuredImage,
      variant.featured_media,
      variant.featuredMedia
    ];
    for (var i = 0; i < candidates.length; i++) {
      var url = productImageUrl(candidates[i]);
      if (url) return url;
    }
    return fallback || '';
  }

  function updateProductCardImage(card, url, alt) {
    if (!url) return;
    var img = card.querySelector('.kz-card__img');
    if (!img) {
      img = document.createElement('img');
      img.className = 'kz-card__img';
      var body = card.querySelector('.kz-card__body');
      card.insertBefore(img, body || card.firstChild);
    }
    if (img.getAttribute('src') !== url) img.src = url;
    img.alt = alt || '';
  }

  function fetchProductDetails(handle) {
    if (productDetailsCache[handle]) return productDetailsCache[handle];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    productDetailsCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
    return productDetailsCache[handle];
  }

  function hydrateProductCardImages(card, product, storefrontProduct) {
    if (!storefrontProduct || !Array.isArray(storefrontProduct.variants)) return;
    var variantsById = {};
    storefrontProduct.variants.forEach(function (variant) {
      variantsById[String(variant.id)] = variant;
    });

    var select = card.querySelector('.kz-card__variant-select');
    if (select) {
      Array.prototype.forEach.call(select.options, function (option) {
        var image = variantImageUrl(variantsById[option.value], '');
        if (image) option.dataset.image = image;
      });
    }

    var cartButton = card.querySelector('.kz-card__cart');
    var selectedId = select && select.value
      ? select.value
      : cartButton && cartButton.dataset.variantId;
    var selectedOption = select && select.options[select.selectedIndex];
    var defaultImage = productImageUrl(product.image || product.featured_image || storefrontProduct.featured_image);
    var selectedImage = (selectedOption && selectedOption.dataset.image)
      || variantImageUrl(variantsById[String(selectedId)], defaultImage);
    updateProductCardImage(card, selectedImage, product.title);
  }

  function renderProductCards(products) {
    if (welcome && welcome.parentNode) welcome.remove();
    var container = document.createElement('div');
    container.className = 'kz-products';
    function getDismissed() { try { return JSON.parse(sessionStorage.getItem('kz_dismissed_cards_br') || '[]'); } catch(e) { return []; } }
    function addDismissed(handle) { var d = getDismissed(); if (d.indexOf(handle) === -1) d.push(handle); try { sessionStorage.setItem('kz_dismissed_cards_br', JSON.stringify(d)); } catch(e) {} }
    var dismissed = getDismissed();
    products = products.filter(function(p) { return dismissed.indexOf(p.handle) === -1; });
    if (!products.length) return;
    container.addEventListener('click', function(e) {
      var btn = e.target.closest('.kz-card__close'); if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var c = btn.closest('.kz-card'); if (!c) return;
      var h = c.getAttribute('data-handle'); if (h) addDismissed(h);
      c.style.opacity = '0'; c.style.transition = 'opacity .15s';
      var par = c.parentNode;
      setTimeout(function() { if (c.parentNode) c.parentNode.removeChild(c); if (par && !par.querySelector('.kz-card')) par.parentNode && par.parentNode.removeChild(par); }, 150);
    });
    if (products.length > 1) {
      var dismissBtn = document.createElement('button');
      dismissBtn.className = 'kz-products__dismiss';
      dismissBtn.textContent = 'Dispensar todos';
      dismissBtn.addEventListener('click', function() {
        products.forEach(function(p) { addDismissed(p.handle); });
        container.style.transition = 'opacity .2s'; container.style.opacity = '0';
        setTimeout(function() { container.remove(); }, 200);
      });
      container.appendChild(dismissBtn);
    }
    products.forEach(function(p) {
      var card = document.createElement('div'); card.className = 'kz-card'; card.setAttribute('data-handle', p.handle);
      renderCardContent(card, p);
      container.appendChild(card);
      if (p.handle) {
        fetchProductDetails(p.handle).then(function (storefrontProduct) {
          if (card.parentNode) hydrateProductCardImages(card, p, storefrontProduct);
        });
      }
    });
    msgEl.appendChild(container); scrollToBottom(true);
    /* Track product impressions so "Mais recomendados" reflects real visibility */
    products.forEach(function(p) { trackEvent('product_view', { handle: p.handle, title: p.title, price: p.price }); });
  }

  // Render card via createElement+textContent — XSS-safe by construction
  // (elimina mistura .innerHTML+escapeHtml que era frágil).
  function renderCardContent(card, p) {
    if (card.replaceChildren) card.replaceChildren();
    else while (card.firstChild) card.removeChild(card.firstChild);

    var allVariants = p.variants || [];
    var variants = allVariants.filter(function (v) { return v.title !== 'Default Title'; });
    var firstAvailable = variants.find(function (v) { return v.available; })
      || allVariants[0]
      || { id: 0, price: p.price, available: false };
    var defaultImage = productImageUrl(p.image || p.featured_image);
    var initialImage = variantImageUrl(firstAvailable, defaultImage);

    var closeBtn = document.createElement('button');
    closeBtn.className = 'kz-card__close';
    closeBtn.textContent = '\u00d7';
    card.appendChild(closeBtn);

    if (initialImage) {
      var img = document.createElement('img');
      img.className = 'kz-card__img';
      img.src = initialImage;
      img.alt = p.title || '';
      card.appendChild(img);
    }

    var body = document.createElement('div');
    body.className = 'kz-card__body';

    var titleEl = document.createElement('div');
    titleEl.className = 'kz-card__title';
    titleEl.textContent = p.title;
    body.appendChild(titleEl);

    var priceWrap = document.createElement('div');
    priceWrap.className = 'kz-card__price';
    var priceCurrent = document.createElement('span');
    priceCurrent.className = 'kz-card__price-current';
    priceCurrent.textContent = fmtBRL(firstAvailable.price || p.price);
    priceWrap.appendChild(priceCurrent);
    var compare = parseFloat(p.compareAtPrice || '0');
    if (compare > parseFloat(firstAvailable.price || p.price)) {
      var priceOld = document.createElement('span');
      priceOld.className = 'kz-card__price-old';
      priceOld.textContent = fmtBRL(p.compareAtPrice);
      priceWrap.appendChild(priceOld);
    }
    body.appendChild(priceWrap);

    var sel = null;
    if (variants.length > 1) {
      var varWrap = document.createElement('div');
      varWrap.className = 'kz-card__variants';
      sel = document.createElement('select');
      sel.className = 'kz-card__variant-select';
      variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.dataset.price = v.price;
        opt.dataset.avail = v.available ? '1' : '0';
        opt.dataset.image = variantImageUrl(v, defaultImage);
        if (v.id === firstAvailable.id) opt.selected = true;
        if (!v.available) opt.disabled = true;
        opt.textContent = v.title + ' - ' + fmtBRL(v.price);
        sel.appendChild(opt);
      });
      varWrap.appendChild(sel);
      body.appendChild(varWrap);
    }

    var actions = document.createElement('div');
    actions.className = 'kz-card__actions';

    var cartAvail = firstAvailable.available;
    var cartBtn = document.createElement('button');
    cartBtn.className = 'kz-card__cart';
    cartBtn.dataset.variantId = firstAvailable.id;
    cartBtn.dataset.price = firstAvailable.price || p.price;
    cartBtn.disabled = !cartAvail;
    cartBtn.textContent = cartAvail ? 'Adicionar ao Carrinho' : 'Esgotado';
    actions.appendChild(cartBtn);

    var link = document.createElement('a');
    link.className = 'kz-card__link';
    link.href = p.url;
    link.target = '_blank';
    link.textContent = 'Detalhes';
    actions.appendChild(link);

    body.appendChild(actions);
    card.appendChild(body);

    if (sel) {
      sel.addEventListener('change', function () {
        var opt = this.options[this.selectedIndex];
        if (!opt) return;
        cartBtn.dataset.variantId = opt.value;
        cartBtn.dataset.price = opt.dataset.price || p.price;
        var avail = opt.dataset.avail === '1';
        cartBtn.disabled = !avail;
        cartBtn.textContent = avail ? 'Adicionar ao Carrinho' : 'Esgotado';
        priceCurrent.textContent = fmtBRL(opt.dataset.price || p.price);
        updateProductCardImage(card, opt.dataset.image || defaultImage, p.title);
      });
    }

    cartBtn.addEventListener('click', function () {
      if (this.disabled) return;
      var vid = parseInt(this.dataset.variantId);
      if (!vid) return;
      this.disabled = true;
      this.textContent = 'Adicionando...';
      var btn = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = '\u2713 Adicionado!';
          btn.style.background = '#17d4e6';
          trackAddToCart(p, vid, btn.dataset.price || p.price);
          showCheckoutBtn();
          setTimeout(function () {
            btn.textContent = 'Adicionar ao Carrinho';
            btn.style.background = '';
            btn.disabled = false;
          }, 3000);
        })
        .catch(function () {
          btn.textContent = 'Erro';
          btn.style.background = '#ef4444';
          setTimeout(function () {
            btn.textContent = 'Adicionar ao Carrinho';
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        });
    });
  }

  /* Fire-and-forget POST to the KZ Desk events endpoint. Silent on failure
     so tracking can never break the chat UX. */
  function trackEvent(eventType, data) {
    try {
      fetch(EVENTS_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: state.sessionId,
          eventType: eventType,
          productHandle: (data && data.handle) || '',
          productTitle: (data && data.title) || '',
          variantId: (data && data.variantId) || '',
          price: (data && data.price) || 0,
          currency: 'BRL'
        })
      });
    } catch(e) {}
  }

  function trackAddToCart(product, variantId, price) {
    try { if (typeof fbq !== 'undefined') fbq('track', 'AddToCart', { content_ids: [String(variantId)], content_name: product.title, content_type: 'product', value: parseFloat(price), currency: 'BRL' }); } catch(e) {}
    try { if (typeof gtag !== 'undefined') gtag('event', 'add_to_cart', { currency: 'BRL', value: parseFloat(price), items: [{ item_id: String(product.id), item_name: product.title, price: parseFloat(price), quantity: 1 }] }); } catch(e) {}
    trackEvent('add_to_cart', { handle: product.handle, title: product.title, variantId: variantId, price: price });
  }

  function trackCheckout(value) {
    try { if (typeof fbq !== 'undefined') fbq('track', 'InitiateCheckout', { value: parseFloat(value) || 0, currency: 'BRL' }); } catch(e) {}
    try { if (typeof gtag !== 'undefined') gtag('event', 'begin_checkout', { currency: 'BRL', value: parseFloat(value) || 0 }); } catch(e) {}
    trackEvent('checkout', { price: value });
  }

  function showCheckoutBtn() {
    var existing = document.getElementById('kzInlineCheckout'); if (existing) existing.remove();
    var wrap = document.createElement('div'); wrap.id = 'kzInlineCheckout'; wrap.style.cssText = 'margin-top:6px;align-self:flex-start';
    var btn = document.createElement('button'); btn.className = 'kz-checkout__btn';
    btn.textContent = '\ud83d\uded2 Finalizar Compra';
    btn.addEventListener('click', function() {
      trackCheckout(0);
      window.location.href = '/checkout';
    });
    wrap.appendChild(btn); msgEl.appendChild(wrap); scrollToBottom(true);
  }

  /* ── Event Listeners ── */
  sendBtn.addEventListener('click', send);
  field.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  });
  field.addEventListener('input', function () {
    this.style.height = 'auto';
    this.style.height = Math.min(this.scrollHeight, 100) + 'px';
  });
  field.addEventListener('focus', function () {
    if (!isMobile()) return;
    setTimeout(function () { scrollToBottom(false); }, 350);
  });
  xferBtn.addEventListener('click', doTransfer);
  phoneInp.addEventListener('keydown', function (e) { if (e.key === 'Enter') doTransfer(); });
  phoneInp.addEventListener('input', function () {
    var v = this.value.replace(/\D/g, '').slice(0, 11);
    if (v.length > 6)      this.value = '(' + v.slice(0, 2) + ') ' + v.slice(2, 7) + '-' + v.slice(7);
    else if (v.length > 2) this.value = '(' + v.slice(0, 2) + ') ' + v.slice(2);
    else if (v.length > 0) this.value = '(' + v;
    this.style.borderColor = '';
  });
})();
